import {TimeTrackerService} from '../app/time-tracker-service.service';
import {Field} from './crud/Field';
import {ModalFields} from './modal-fields';
import {Config} from './crud/Config';

export class AllowedDevice {
    public id: string;
    public name: string;
    public date: number;
    public mac: string;
    public allowed: boolean;

    constructor() {

    }

    static toModelTemplate(allowedDevice: AllowedDevice, companyId: String) {
        const path = TimeTrackerService.COMPANY_DATA + '/' + companyId + '/' + TimeTrackerService.ALLOWED_DEVICES;

        const idField = new Field('id', 'id', 'text', false);
        const nameField = new Field('MODEL.ALLOWED_DEVICE.NAME', 'name', 'text', true);
        const dateField = new Field('MODEL.ALLOWED_DEVICE.DATE', 'date', 'date', true);
        const macField = new Field('MODEL.ALLOWED_DEVICE.MAC', 'mac', 'text', true);
        const allowedField = new Field('MODEL.ALLOWED_DEVICE.ALLOWED', 'allowed', 'checkbox', false);

        nameField.class = 'col-4';
        macField.class = 'col-4';
        allowedField.class = 'col-4';

        if (allowedDevice != null) {
            idField.value = allowedDevice.id;
            nameField.value = allowedDevice.name;
            dateField.value = allowedDevice.date;
            macField.value = allowedDevice.mac;
            allowedField.value = allowedDevice.allowed;
        } else {
            dateField.value = new Date();
            allowedField.value = true;
        }

        idField.hidden = true;
        const modalFields = new ModalFields([idField, nameField, macField, allowedField],
            new Config(''), false, false, false
        );

        modalFields.firebaePath = path;
        return modalFields;
    }

}



// WEBPACK FOOTER //
// ./src/models/AllowedDevice.ts